/* Product page: variant selection (Section Rendering API), quantity stepper, thumbnails, free delivery mini meter. */
(function () {
  var root = document.querySelector('[data-product-section]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var productUrl = root.getAttribute('data-product-url');
  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) {}
  var form = root.querySelector('[data-product-form]');
  var qty = root.querySelector('[data-qty]');
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: currency });

  function selectedValues() {
    var vals = [];
    root.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
      var c = fs.querySelector('input[data-option]:checked');
      vals[parseInt(fs.getAttribute('data-option-index'), 10)] = c ? c.value : null;
    });
    return vals;
  }

  function findVariant(vals) {
    return variants.filter(function (v) {
      return v.options.every(function (o, i) { return vals[i] === o; });
    })[0];
  }

  function swapRegions(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    ['main-image', 'meta', 'price', 'sticky-info'].forEach(function (name) {
      var cur = document.querySelector('[data-dyn="' + name + '"]');
      var next = doc.querySelector('[data-dyn="' + name + '"]');
      if (cur && next) cur.replaceWith(next);
    });
    var newAtc = doc.querySelector('[data-atc]');
    var atc = document.querySelector('[data-atc]');
    if (newAtc && atc) {
      atc.disabled = newAtc.disabled;
      atc.querySelector('[data-atc-label]').textContent = newAtc.querySelector('[data-atc-label]').textContent;
    }
    var newSticky = doc.querySelector('[data-sticky-submit]');
    var sticky = document.querySelector('[data-sticky-submit]');
    if (newSticky && sticky) sticky.disabled = newSticky.disabled;
    syncThumbs();
  }

  function syncThumbs() {
    var img = document.querySelector('[data-main-image]');
    if (!img) return;
    document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('on'); });
  }

  function onVariantChange() {
    var v = findVariant(selectedValues());
    var idInput = form.querySelector('[data-variant-id]');
    var atc = form.querySelector('[data-atc]');
    if (!v) {
      if (atc) { atc.disabled = true; atc.querySelector('[data-atc-label]').textContent = (window.themeConfig && themeConfig.strings && themeConfig.strings.unavailable) || ''; }
      return;
    }
    idInput.value = v.id;
    history.replaceState(null, '', productUrl + '?variant=' + v.id);
    fetch(productUrl + '?variant=' + v.id + '&section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(swapRegions)
      .catch(function () {});
  }

  /* The meter shows the whole cart, not this product: it follows cart:updated from cart.js. */
  function updateShip() {
    var el = document.querySelector('[data-ship-mini]');
    if (!el) return;
    var threshold = parseInt(el.getAttribute('data-threshold'), 10);
    var price = parseInt(el.getAttribute('data-subtotal'), 10) || 0;
    var left = threshold - price;
    var meter = el.querySelector('.ship-meter');
    if (!meter) return;
    var bar = meter.querySelector('.bar');
    var tpl = left > 0 ? el.getAttribute('data-tpl-left') : el.getAttribute('data-tpl-free');
    var text = left > 0 ? tpl.replace('__amount__', fmt.format(left / 100)) : tpl;
    meter.innerHTML = text;
    var b = document.createElement('div');
    b.className = 'bar';
    b.innerHTML = '<i style="width:' + Math.min(100, price / threshold * 100) + '%"></i>';
    meter.appendChild(b);
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-option]')) onVariantChange();
  });

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step && qty) {
      var n = (parseInt(qty.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
      qty.value = Math.max(1, n);
      return;
    }
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) showThumb(thumb);
  });

  function showThumb(thumb) {
    var img = document.querySelector('[data-main-image]');
    if (img) { img.removeAttribute('srcset'); img.src = thumb.getAttribute('data-src'); }
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
    thumbs.forEach(function (t) { t.classList.toggle('on', t === thumb); });
    var count = document.querySelector('[data-img-count]');
    if (count) count.textContent = (thumbs.indexOf(thumb) + 1) + ' / ' + thumbs.length;
  }

  /* Swipe the main image on touch screens to move through the gallery. */
  var startX = null, startY = 0;
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('.main-img')) { startX = null; return; }
    startX = e.touches[0].clientX; startY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (startX === null) return;
    var dx = e.changedTouches[0].clientX - startX;
    var dy = e.changedTouches[0].clientY - startY;
    startX = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
    if (thumbs.length < 2) return;
    var cur = 0;
    thumbs.forEach(function (t, i) { if (t.classList.contains('on')) cur = i; });
    var next = dx < 0 ? cur + 1 : cur - 1;
    if (next < 0 || next >= thumbs.length) return;
    showThumb(thumbs[next]);
  }, { passive: true });
  function setSubtotal(cents) {
    var el = document.querySelector('[data-ship-mini]');
    if (!el || isNaN(cents)) return;
    el.setAttribute('data-subtotal', cents);
    updateShip();
  }
  document.addEventListener('cart:updated', function (e) { setSubtotal(e.detail && e.detail.subtotal); });
  /* Page restored from the back/forward cache: the rendered cart total may be stale. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setSubtotal(c.items_subtotal_price); }).catch(function () {});
  });
})();
